// extracted by mini-css-extract-plugin
export default {"card":"SubscriptionCard_card__NkdZ3","status":"SubscriptionCard_status__jsj5s"};